import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from "vue";
import { Project } from "@/types";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import StatusTool from "@/components/general/StatusTool.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCardTools',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
    noUpdate: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;

const uiStore = useUiStore();

const prevStatus = () => {
    props.project.projectStatus -= 1;
    update();
};

const nextStatus = () => {
    props.project.projectStatus += 1;
    update();
};

const update = () => {
    if (!props.noUpdate) {
        api.update(props.project, "projects").then(() => {
            uiStore.message("Wijzigingen opgeslagen...");
        });
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ProjectCardTools",
    style: _normalizeStyle({
            'flex-direction':
                __props.project.projectStatus === 0 ? 'row-reverse' : 'row',
        })
  }, [
    _withDirectives(_createVNode(StatusTool, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (prevStatus())),
      direction: "up"
    }, null, 512), [
      [_vShow, __props.project.projectStatus > 0]
    ]),
    _withDirectives(_createVNode(StatusTool, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (nextStatus())),
      direction: "down"
    }, null, 512), [
      [_vShow, __props.project.projectStatus < 5]
    ])
  ], 4))
}
}

})